module.exports = __webpack_public_path__ + "static/media/8OLA14.d3c148ed.jpg";